<template>
  <div class="main-view">
    <div
      v-if="whiteLabelCeline"
      class="header"
    >
      <h4 class="title">
        {{ i18nFieldValue(maintag, 'name') }}
      </h4>
      <h5
        v-if="collectionNames[0]"
        class="title"
      >
        {{ collectionNames[0] }}
      </h5>
      <pre class="description header__description">{{ i18nFieldValue(maintag, 'description') }}</pre>
    </div>
    <div class="body">
      <div class="left">
        <img
          v-if="whiteLabelCeline"
          class="main-photo"
          :src="maintag.images[0]"
          @contextmenu.prevent="rightClickBlock"
          @click="$emit('preview', 0)"
        >
        <h4
          v-if="!whiteLabelCeline"
          class="title"
        >
          {{ i18nFieldValue(maintag, 'name') }}
        </h4>
        <h5
          v-if="collectionNames[0]"
          class="title"
        >
          {{ collectionNames[0] }}
        </h5>
        <i-tag-list
          class="marker-info-category"
          :tags="maintag.categoryMulti[$i18n.locale] || maintag.category"
        />
        <div class="main-action">
          <template v-if="collectionNames[0]">
            <span class="overflow-ellipsis">{{ findWholesalePrice(maintag) }}</span>
          </template>
          <template v-else>
            <template v-if="!isJoorActionTag(maintag)">
              <span class="overflow-ellipsis">{{ i18nFieldValue(maintag, 'price') }}</span>
            </template>
          </template>
          <template v-if="isJoorActionTag(maintag) && isInJoorPlatform || !isJoorActionTag(maintag)">
            <a
              v-if="maintag.action"
              class="cta-btn overflow-ellipsis"
              @click="handleActionClick(maintag, 0)"
            >
              {{ getActionMutate(maintag) }}
            </a>
          </template>
        </div>
        <template v-if="!whiteLabelCeline">
          <div class="main-photo-wrapper">
            <button
              v-if="isMainTagArViewButtonVisible"
              ref="maintagTooltipButton"
              class="arview-button"
              @mouseenter="showMainTagViewIn3DTooltip"
              @mouseleave="hideMainTagViewIn3DTooltip"
              @click="showArView(maintag)"
            >
              <img :src="require('@/assets/images/armaker/arview-cube.png')">
              <div
                v-if="isMainTagViewIn3DTooltipVisible"
                class="tooltip"
              >
                {{ $t('viewIn3D') }}
              </div>
            </button>
            <img
              class="main-photo"
              :src="maintag.images[0]"
              @contextmenu.prevent="rightClickBlock"
              @click="$emit('preview', 0)"
            >
          </div>
          <pre class="description">{{ i18nFieldValue(maintag, 'description') }}</pre>
        </template>
      </div>
      <div class="right">
        <div class="gallery hide-scroll">
          <div
            v-for="(subtag, i) in subtags"
            :key="subtag.objectId"
            class="gallery__item"
          >
            <div class="sub-photo-wrapper">
              <button
                v-if="isArViewButtonVisible(subtag)"
                class="arview-button"
                @click="showArView(subtag)"
              >
                <img :src="require('@/assets/images/armaker/arview-cube.png')">
              </button>
              <img
                v-if="subtag.photo"
                class="gallery__photo"
                :src="subtag.images[0]"
                @click="$emit('preview', i + 1)"
                @contextmenu.prevent="rightClickBlock"
              >
            </div>
            <div class="gallery__info hide-scroll">
              <h5 class="title">
                {{ i18nFieldValue(subtag, 'name') }}
              </h5>
              <h5
                v-if="collectionNames[i + 1]"
                class="title"
              >
                {{ collectionNames[i + 1] }}
              </h5>
              <i-tag-list
                class="marker-info-category"
                :tags="subtag.categoryMulti[$i18n.locale] || subtag.category"
              />
              <pre class="description">{{ i18nFieldValue(subtag, 'description') }}</pre>
            </div>
            <div
              v-if="subtag.action"
              class="gallery__action"
            >
              <template v-if="isJoorActionTag(subtag) && isInJoorPlatform || !isJoorActionTag(subtag)">
                <a
                  class="cta-btn overflow-ellipsis"
                  :title="getActionMutate(subtag)"
                  @click="handleActionClick(subtag, i + 1)"
                  v-text="getActionMutate(subtag)"
                />
              </template>
              <template v-if="collectionNames[i + 1]">
                <span class="overflow-ellipsis">{{ findWholesalePrice(subtag) }}</span>
              </template>
              <template v-else>
                <template v-if="!isJoorActionTag(subtag)">
                  <span
                    class="overflow-ellipsis"
                    :title="i18nFieldValue(subtag, 'price')"
                  >{{ i18nFieldValue(subtag, 'price') }}</span>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Message, Loading } from 'element-ui'
import ITagList from '@/components/ITagList'
import { WHITE_LABEL_CELINE } from '@/api/constants'
import { AR_VIEW_ENABLE_MARKERS } from '@/api/armaker'

export default {
  components: {
    ITagList
  },
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    i18nFieldValue: {
      type: Function,
      default: () => {}
    },
    getActionMutate: {
      type: Function,
      default: () => {}
    },
    isJoorActionTag: {
      type: Function,
      default: () => {}
    },
    collectionNames: {
      type: Array,
      default: () => []
    },
    availablePriceType: {
      type: Array,
      default: () => []
    },
    customSetting: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      whiteLabelCeline: WHITE_LABEL_CELINE,
      isMainTagViewIn3DTooltipVisible: false,
      showMainTagViewIn3DTooltipTimer: null,
      hideMainTagViewIn3DTooltipTimer: null
    }
  },
  computed: {
    ...mapGetters('joor', [
      'priceType',
      'products',
      'skus',
      'currentPriceType',
      'accessToken',
      'orders',
      'collections',
      'isInJoorPlatform'
    ]),
    maintag () {
      return this.tags[0]
    },
    subtags () {
      return this.tags.slice(1)
    },
    arViewEnabled () {
      return this.customSetting.arView && AR_VIEW_ENABLE_MARKERS.includes('multitag')
    },
    isMainTagArViewButtonVisible () {
      const arViewAction = this.maintag.arView ? this.maintag.arView.action : null
      const arViewUrl = arViewAction ? arViewAction.url : ''
      return this.arViewEnabled && !!arViewUrl
    }
  },
  watch: {
    isMainTagArViewButtonVisible: {
      handler (val) {
        if (val) {
          this.showMainTagViewIn3DTooltipTimer = setTimeout(() => {
            this.isMainTagViewIn3DTooltipVisible = true
            this.hideMainTagViewIn3DTooltipTimer = setTimeout(() => {
              this.isMainTagViewIn3DTooltipVisible = false
            }, 5000)
          }, 3000)
        } else {
          this.isMainTagViewIn3DTooltipVisible = false
          this.clearViewIn3DTooltipTimer()
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions([
      'setPopupUrl',
      'setPopupSizeConfig',
      'showPopup'
    ]),
    ...mapActions('joor', [
      'addToOrderProcess'
    ]),
    ...mapActions('arview', [
      'showArViewPopup',
      'closeArViewPopup',
      'setArViewPopupAction',
      'setArViewPopupSize'
    ]),
    rightClickBlock (e) {
      e.preventDefault()
    },
    handleActionClick (tag, index) {
      if (this.isJoorActionTag(tag) && this.isInJoorPlatform) {
        this.addJoorItemProcess(tag, index)
        return
      }
      const url = this.i18nFieldValue(tag, 'actionLink')
      if (tag.actionType === 'iframe' || tag.actionType === 'largerIframe') {
        this.setPopupUrl(url)
        this.setPopupSizeConfig() // Set Defaults
        if (tag.actionType === 'largerIframe') {
          this.setPopupSizeConfig({
            widthPercent: 90,
            fullHeight: true
          })
        }
        this.showPopup()
      } else {
        window.open(url)
      }
    },
    async addJoorItemProcess (tag, index) {
      if (!this.collectionNames[index] || this.availablePriceType.length < 1) {
        Message.warning(this.$t('productUnavailable'))
        return
      }
      if (!this.currentPriceType.id) {
        Message.warning('Please select price type.')
        return
      }
      if (!this.findWholesalePrice(tag)) {
        Message.warning('The style is not support the selected price type.')
        return
      }
      const loadingInstance = Loading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        await this.addToOrderProcess(tag)
        Message.success('Add style to cart success!')
        this.notifyAddItemToCartSuccess()
        loadingInstance.close()
      } catch (error) {
        console.error(error)
        Message.error(error)
        loadingInstance.close()
      }
    },
    findWholesalePrice (tag) {
      if (this.currentPriceType.id) {
        const currentSkuIds = this.products[tag.customAttribute.joorProductId]
        const targetSkuId = currentSkuIds ? currentSkuIds.find(skuId => this.currentPriceType.skus[skuId]) : ''
        if (targetSkuId) {
          return this.currentPriceType.skus[targetSkuId].wholesale_value
        }
      }
      return ''
    },
    findCollectionName (tag) {
      if (this.isJoorActionTag(tag) && this.isInJoorPlatform) {
        const currentCollection = this.collections.find(collection => collection.id === tag.customAttribute.joorCollectionId)
        return currentCollection ? currentCollection.name : ''
      }
      return ''
    },
    notifyAddItemToCartSuccess () {
      window.parent.postMessage(
        JSON.stringify({
          error: false,
          success: true,
          message: 'Product Added'
        }),
        '*'
      )
    },
    clearViewIn3DTooltipTimer () {
      clearTimeout(this.showMainTagViewIn3DTooltipTimer)
      clearTimeout(this.hideMainTagViewIn3DTooltipTimer)
      this.showMainTagViewIn3DTooltipTimer = null
      this.hideMainTagViewIn3DTooltipTimer = null
    },
    showArView (tag) {
      const arViewAction = tag.arView.action
      const arViewSize = tag.arView.size
      const arViewActionTarget = arViewAction.target || 'iframe'
      if (arViewActionTarget === 'iframe') {
        this.setArViewPopupAction(arViewAction)
        this.setArViewPopupSize(arViewSize)
        this.showArViewPopup()
      }
    },
    showMainTagViewIn3DTooltip () {
      this.isMainTagViewIn3DTooltipVisible = true
      this.clearViewIn3DTooltipTimer()
    },
    hideMainTagViewIn3DTooltip () {
      this.isMainTagViewIn3DTooltipVisible = false
    },
    isArViewButtonVisible (subtag) {
      const arViewAction = subtag.arView ? subtag.arView.action : null
      const arViewUrl = arViewAction ? arViewAction.url : ''
      return this.arViewEnabled && !!arViewUrl
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/common/arview'

$font-size-s = 14px
$font-size-xs = 12px
.main-view {
  display: flex
  flex-direction: column
}
.header {
  margin-bottom: 10px
  .header__description {
    min-height: 13px
  }
}
.body {
  display: flex
  height: 100%
  min-height: 0
  overflow-x: auto
  .left {
    display: flex
    flex-direction: column
    align-items: start
    overflow: auto
    margin-right: 20px
    height: 100%
    max-width: 280px
    min-width: 280px
  }
  .right {
    height: 100%
    width: 100%
    min-width: 300px
  }
}
.main-photo-wrapper {
  width: 100%
  position: relative

  .arview-button {
    right: 35px
    bottom: 15px
  }
}
.main-photo {
  margin-bottom: 10px
  width: 100%
  object-fit: cover
}

.main-action {
  min-height: 20px
  align-self: stretch
  display: flex
  justify-content: space-between
}
.sub-photo-wrapper {
  position: relative

  .arview-button {
    right: 15px
    bottom: 15px
  }
}
.gallery {
  $gallery-item-height = 160px
  display: flex
  flex-direction: column
  overflow: auto
  height: 100%
  .gallery__photo {
    max-width: $gallery-item-height
    min-width: $gallery-item-height
    height: $gallery-item-height
    margin-right: 10px
    text-align: left
    object-fit: contain
  }
  .gallery__info {
    overflow: auto
    height: $gallery-item-height
    word-break: break-word
  }
  .gallery__action {
    display: flex
    flex-direction: column
    align-items: flex-end
    margin-left: auto
    min-width: 100px
  }
  .gallery__item {
    display: flex
    flex-direction: row
    position relative
    margin: 0 5px 10px 5px
    min-height: $gallery-item-height // 這邊safari flex column 如果高度只由內容撐開會失效破版 所以設置minheight
    &:hover {
      background-color: rgba(255, 255, 255, 0.1)
    }
  }
}
.title {
  font-size: $font-size-s
}
.description {
  font-size: $font-size-xs
  white-space: pre-wrap
  margin-top: 1em
  line-height: 1.2
}
.cta-btn {
  color: #fff
  display: inline-block
  padding-bottom: 1px
  margin-bottom: 2px
  font-size: $font-size-s
  font-weight: bold
  text-shadow: none
  border-bottom: 1.5px solid #fff
  cursor: pointer
}
.hide-scroll::-webkit-scrollbar {
  display: none;
}
.hide-scroll {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.overflow-ellipsis {
  max-width: 100%
}
</style>
